var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZocialPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.507,
    height: 35.071,
    viewBox: "0 0 40.507 35.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-print",
    "data-name": "Icon zocial-print",
    d: "M.18,39.031v-14.6l5.085-5.655H8.992v2.806H6.537l-3.507,3.9V36.226H37.882V25.485l-3.507-3.9H31.92V18.778h3.726l5.042,5.655v14.6H.18ZM8.992,25.047V10.58l6.62-6.62H31.92V25.047Zm2.63-2.674H29.289V6.59H18.242v6.62h-6.62Z",
    transform: "translate(-0.18 -3.96)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZocialPrint);
export default __webpack_public_path__ + "static/media/zocial-print.5f2d3f8af4edbc4e77550cfe253c9502.svg";
export { ForwardRef as ReactComponent };